import { usePrismicDocumentByUID } from "../prismic-hooks"
import React from "react"
import PageContent from "../components/PageContent"

export default function People() {
    const [document] = usePrismicDocumentByUID('gcc_content_page', 'people');
    return <PageContent document={document} sectionClass='home' />;
}